// extracted by mini-css-extract-plugin
module.exports = {"ctalogo":"OrganisatieRowLogo-module--ctalogo--2IKeY","text":"OrganisatieRowLogo-module--text--h1reH","innerPadding":"OrganisatieRowLogo-module--innerPadding--1_iOS"};